
<template>
    <div>
    <el-dialog title="师傅详情" @close="close" width="900px" :visible.sync="dialogFormVisible">
        <div class="container" style="margin-top:15px;height:500px;overflow:auto;">
            <el-card class="box-card" style="margin-bottom:15px;">
                <el-row style="margin-bottom: 8px;">
                    <el-col :span="4" style="text-align: center;">
                         <el-row style="margin-bottom: 8px;line-height: 40px;">
                            <el-col :span="24" style="text-align: center;">
                                <img :src="avatar" style="height: 80px;width: 80px;border-radius: 50%;">
                            </el-col>
                             <el-col :span="24" style="text-align: center;">
                                <el-tag>{{status==1?'正常':'已冻结'}}</el-tag>
                            </el-col>
                         </el-row>
                    </el-col>
                    <el-col :span="20">
                        <el-row style="margin-bottom: 8px;line-height: 40px;">
                            <el-col :span="8" style="text-align: left;">师傅昵称 : {{userName?userName:''}}</el-col>
                            <el-col :span="8" style="text-align: left;">联系电话 : {{phone?phone:''}}</el-col>
                            <el-col :span="8" style="text-align: left;">实名认证 : {{isworkstate(workerState)}}</el-col>
                            <el-col :span="8" style="text-align: left;">团队认证 : {{isForeman==1?"已认证":"未认证"}}</el-col>
                            <el-col :span="8" style="text-align: left;">所在城市 : {{serviceRegion?serviceRegion:''}}</el-col>
                            <el-col :span="8" style="text-align: left;">创建时间 : {{createtime?settime(createtime):''}}</el-col>
                            <el-col :span="24" style="text-align: left;">工种信息 : {{workTypeIds?setWorktype(workTypeIds):''}}</el-col>
                            <el-col :span="24" style="text-align: left;">技能信息 : {{skillTips?setskill(skillTips):''}}</el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;" v-if="cardName&&cardNum">
                <el-row style="margin-bottom: 8px;">
                    <el-col :span="24">
                        <el-row style="margin-bottom: 8px;line-height: 40px;margin:0 15px;">
                            <el-col :span="12" style="text-align: left;padding-left:20px;">身份证名称 : {{cardName?cardName:''}}</el-col>
                            <el-col :span="12" style="text-align: left;padding-left:15px;">身份证号码 : {{cardNum}}</el-col>
                            <el-col :span="12" style="text-align: center;" v-if="cardFrontImg">
                                <img :src="cardFrontImg" preview="1" style="max-width:380px;max-height:300px;border: 1px solid #eee;cursor:pointer;">
                                <p style="text-align: center;color: #d5d6db;">身份证正面照片</p>
                            </el-col>
                            <el-col :span="12" style="text-align: center;" v-if="cardBackImg">
                                <img :src="cardBackImg" preview="1" style="max-width:380px;max-height:300px;border: 1px solid #eee;cursor:pointer;">
                                <p style="text-align: center;color: #d5d6db;">身份证反面照片</p>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="box-card" style="margin-bottom:15px;" v-else>
                <el-row style="margin-bottom: 8px;">
                    <el-col :span="24">
                        <p style="text-align: center;color: #d5d6db;">未认证，暂无实名信息</p>
                    </el-col>
                </el-row>
            </el-card>
             <el-card class="box-card" style="margin-bottom:15px;">
                 <p style="margin-left:15px;">已列入黑名单的公司</p>
                <el-row style="margin-bottom: 8px;">
                    <el-col :span="24" v-for="item in blacklist" :Key="item">
                      <span style="margin-left:15px;">{{item.name}}</span>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="status==1" class="filter-item" size="mini" @click="handleStop" type="primary" icon="el-icon-circle-close-outline" >冻结</el-button>
            <el-button v-if="status==2" class="filter-item" size="mini" @click="handleStart"  type="primary" icon="el-icon-circle-check-outline">解冻</el-button>
            <el-button  @click="approved"  v-if="workstate=='shz'" class="filter-item" size="mini" type="primary" icon="el-icon-circle-check-outline" >认证通过</el-button>
            <el-button @click="noapproved"  v-if="workstate=='shz'" class="filter-item" size="mini" type="primary" icon="el-icon-circle-check-outline" >认证不通过</el-button>
            <el-button class="filter-item" size="mini" @click="deletestate" type="primary" icon="el-icon-circle-check-outline">删除
            </el-button>
        </div>
    </el-dialog>
     <workercald ref="childcald" @refresh="refresh"></workercald>
    </div>
</template>
<script>
    import {stop,getObj,dictionary,getblack,deleteWorker} from '@/api/admin/workerUser'
    import {getImgLink} from '@/config/env'
    import {mapGetters} from 'vuex'
    import {dateOnce} from '@/util/dateT'
    import {objKeySort } from '@/util/ajaxsign'
    import workercald from './workercald.vue'

    export default {
        components: {workercald},
        data() {
            return {
                userId : '',
                dialogFormVisible : false,
                dictionarylist : [],
                avatar : '',
                status : '',
                userName : '',
                phone : '',
                isForeman : '',
                serviceRegion : '',
                createtime : '',
                workTypeIds : '',
                skillTips : '',
                cardName : '',
                cardNum : '',
                cardFrontImg : '',
                cardBackImg : '',
                workerState : '',
                blacklist : [],
                workstate : ''
            }
        },
        created() {},
        mounted() {},
        methods: {
            //刷新列表操作
            refresh(){
                this.getCompanyInfo();
                this.$emit('refresh');
            },
            //设置展示
            setsataus(data,dictionarylist){
                this.dialogFormVisible = true;
                this.userId = data;
                this.dictionarylist = dictionarylist;
                this.getCompanyInfo();
                this.getblacklist();
            },

            //身份证处理
            cardnumset(data){
                let str = data.split(""),cardnum='';
                for(var i = 0;i<str.length;i++){
                    if(i==0||i==str.length-1){
                        cardnum = cardnum+str[i];
                    }else{
                        cardnum = cardnum+"*";
                    }
                }
                return  cardnum;
            },

            //项目详情数据请求
            getCompanyInfo(){
                getObj(objKeySort({userId:this.userId})).then(response => {
                    this.avatar = response.data.data.avatar?getImgLink(response.data.data.avatar) :response.data.data.headimgurl?response.data.data.headimgurl:'/img/default-avatar.png';
                    this.status = response.data.data.status;
                    this.userName = response.data.data.userName;
                    this.phone = response.data.data.phone;
                    this.isForeman = response.data.data.isForeman;
                    this.serviceRegion = response.data.data.serviceRegion;
                    this.createtime = response.data.data.createtime;
                    this.workTypeIds = response.data.data.workTypeIds;
                    this.skillTips = response.data.data.skillTips;
                    this.cardName = response.data.data.cardName;
                    this.cardNum = response.data.data.cardNum;
                    this.cardFrontImg = response.data.data.cardFrontImg?getImgLink(response.data.data.cardFrontImg):'';
                    this.cardBackImg  = response.data.data.cardBackImg?getImgLink(response.data.data.cardBackImg):'';
                    this.workerState = response.data.data.workerState;
                })
            },

            //获取黑名单
            getblacklist(){
                getblack(objKeySort({userId:this.userId})).then(response => {
                    this.blacklist = response.data.data;
                })
            },

             //删除
            deletestate(){
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteWorker(objKeySort({userId : this.userId})).then(response => {
                        this.refresh()
                        this.dialogFormVisible = false;
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            //默认时间
            settime(data){
                return dateOnce(data)
            },


            // //字典数据转化
            setWorktype(data){
                let worktype = data.split(','),typename='';
                for(var i=0;i<worktype.length;i++){
                    for(var j=0;j<this.dictionarylist.worktype.length;j++){
                        if(Number(worktype[i]) == this.dictionarylist.worktype[j].id){
                            typename+=' '+this.dictionarylist.worktype[j].name
                        }
                    }
                }
                return typename
            },

            // //设置技能转化
            setskill(data){
                let worktype = data.split(','),typename='';
                    for(var i=0;i<worktype.length;i++){
                        for(var j=0;j<this.dictionarylist.worker_skill.length;j++){
                            if(Number(worktype[i]) == this.dictionarylist.worker_skill[j].id){
                                typename+=' '+this.dictionarylist.worker_skill[j].name
                            }
                        }
                    }
                return typename
            },
            //冻结
            handleStop() {
                this.$refs.childcald.setsataus(this.userId,"冻结原因");
            },

            handleStart(){
                stop(objKeySort({userId:this.userId,status:1})).then(response =>{
                    this.$message({
                        title: '解冻成功',
                        message: '解冻成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.refresh()
                })
            },

            //认证通过
            approved(){
                stop(objKeySort({userId:this.userId,status:2})).then(response =>{
                    this.$message({
                        title: '认证通过',
                        message: '认证通过',
                        type: 'success',
                        duration: 2000
                    })
                    this.refresh()
                })
            },
            //认证不通过
            noapproved(){
                this.$refs.childcald.setsataus(this.userId,"拒绝原因");
            },

            //取消回调
            close(){
                console.log("取消")
            },

            isworkstate(data){
                console.log(data)
                // 0或空，未认证；1，审核中；2审核通过；3拒绝审核
                if(data == 1){
                    this.workstate = 'shz';
                    return  '审核中'
                }else if(data == 2){
                    this.workstate = 'ysm';
                    return  '已实名'
                }else if(data == 3){
                     this.workstate = 'jjsh'
                    return  '拒绝审核'
                }else{
                    this.workstate == 'wsm'
                    return  '未实名'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.container{
    min-width:800px;
    max-width:900px;
}
.form_layout_items{
    display:flex
}
.select_option{
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
}
.el-table /deep/ .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .form_layout_item{
      width:50%;
      border:1px solid #fff;
      height:80px;
  }
</style>
